import React from "react";
import Box from "@amzn/meridian/box";
import _ from "lodash";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import { useSheets } from "../../features/sheets/hooks";
import { DisplaySpacesOnForm } from "./DisplaySpacesOnForm";
import { Space } from "../space/Space";
import { DisplayFeaturesOnForm } from "./DisplayFeaturesOnForm";
import { AddSpaceForm } from "./AddSpaceForm";
import { addFeatureInitialValues, addSpaceInitialValues } from "./definitions";
import { AddFeatureForm } from "./AddFeatureForm";
import { useFormikContext } from "formik";

export const SheetFormInput = ({ inputProps, field, sheetName, form }) => {
    const { updateSheets, setOpenSheets } = useSheets();

    const sheetRetriever = (sheetName, onSubmitHandler, initialValues?) => {
        switch (sheetName) {
            case "addSpace": {
                return (
                    <AddSpaceForm
                        initialValues={initialValues || addSpaceInitialValues}
                        onSubmitHandler={onSubmitHandler}
                    />
                );
            }
            case "addFeature": {
                return (
                    <AddFeatureForm
                        initialValues={initialValues || addFeatureInitialValues}
                        onSubmitHandler={onSubmitHandler}
                    />
                );
            }
        }
    };

    const editSubmitHandler = (currentItem, currentItemId) => {
        form.setFieldValue(
            field.name,
            field.value.map(item => {
                return item.id === currentItemId
                    ? {
                          id: _.uniqueId(),
                          ...currentItem[sheetName],
                      }
                    : item;
            })
        );
    };

    const handleEditUpdateSheetAndOpen = (sheetName, currentItemId) => {
        updateSheets(
            sheetRetriever(
                sheetName,
                editedItem => {
                    editSubmitHandler(editedItem, currentItemId);
                },
                {
                    [sheetName]: field?.value.filter(item => item.id === currentItemId)[0],
                }
            )
        );
        setOpenSheets(true);
    };

    const handleDeleteItem = currentItemId => {
        form.setFieldValue(
            field.name,
            field.value.filter(item => item.id !== currentItemId)
        );
    };
    const { errors, getFieldMeta } = useFormikContext<any>();

    const getDisplayForms = sheetName => {
        switch (sheetName) {
            case "addSpace": {
                return (
                    <React.Fragment>
                        <DisplaySpacesOnForm
                            spaceDetails={field?.value}
                            sheetName={sheetName}
                            handleEditUpdateSheetAndOpen={handleEditUpdateSheetAndOpen}
                            handleDeleteItem={handleDeleteItem}
                        />
                    </React.Fragment>
                );
            }
            case "addFeature": {
                return (
                    <DisplayFeaturesOnForm
                        featureDetails={field?.value}
                        sheetName={sheetName}
                        handleEditUpdateSheetAndOpen={handleEditUpdateSheetAndOpen}
                        handleDeleteItem={handleDeleteItem}
                    />
                );
            }
        }
    };

    return (
        <Box width={"100%"} key={_.uniqueId("Sheet_box")}>
            <Text color={"error"}> {errors ? getFieldMeta(field.name).error : null} </Text>
            {!field?.value?.length ? <Text> {inputProps.emptyState} </Text> : null}
            {field?.value?.length ? getDisplayForms(sheetName) : null}

            <Space size={"xs"} />
            <Button
                {...inputProps}
                onClick={() => {
                    updateSheets(
                        sheetRetriever(sheetName, values => {
                            form.setFieldValue(field.name, [
                                ...field.value,
                                {
                                    id: _.uniqueId(),
                                    ...values[sheetName],
                                },
                            ]);
                        })
                    );
                    setOpenSheets(true);
                }}
            >
                {" "}
                {inputProps.label}
            </Button>
        </Box>
    );
};
